export default "__VITE_ASSET__c8ffa010__"